<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>  
    <b-row class='mb-4'>
      <b-col v-for='(locale, i) in locales' :key='i'>
        <label :for="`flatpage${flatPage.id}_link_locale${i}`">Link {{locale}}</label>
        <b-form-input
          :id="`flatpage${flatPage.id}_link_locale${i}`"
          :value='item.value ? item.value[locale] : ""'
          @input='(e) => actions.handleItemTextValueChanged(flatPage.id, item.id, e, locale)'
        />
      </b-col>
    </b-row>
    <b-row class='mb-4'>
      <b-col cols="6">
        <label>Wysokość webview</label>
        <b-form-input
          :value='item.value && item.value.height ? item.value.height : 200'
          type='number'
          @input='(e) => actions.handleItemYoutubeValueChanged(flatPage.id, item.id, "height", e)'
        />
      </b-col>
    </b-row>
  </div>
</template>


<script>
  import { LOCALES } from '@/utils';
  import {
    handleItemTextValueChanged,
    handleItemYoutubeValueChanged
  } from '@/store/utils.js'

  export default {
    props: ['flatPage', 'item'],
  
    computed: {
      link(locale) {
        try {
          return this.item.style.marginTop || 10
        } catch (e) {
          return 10
        }
      }
    },
    data() {
      return {
        actions: {
          handleItemTextValueChanged,
          handleItemYoutubeValueChanged
        },
        locales: LOCALES,
      }
    },
  }
</script>
